import styled, { css } from 'styled-components'
import { defaultSectionTheme } from '@/constants'

const MAX_SLIDES = 4
const DESIGN_MAX_SLIDES = 3

export const Wrapper = styled.div<{ length: number, hasInnerShadow: boolean }>`
  overflow: visible;
  padding-bottom: ${props => props.length > 1 ? 15 : 0}px;

  .slick-track {
    display: flex;
    ${props => props.length === 1 && 'justify-content: center;'}
  }

  // padding for when dots show up
  & > .slick-slider {
    padding-bottom: ${props => props.length > 1 ? 35 : 0}px;
  }

  // For showing the next slides
  .slick-list {
    overflow: visible;
    margin: 0 -${props => props.length >= 3 ? 15 : 0}px;

    .slick-slide {
      height: auto;
      width: auto;

      ${props => props.length <= 2 && css`
        &:first-child {
          & > div {
            padding-left: 0;
          }
        }

        &:last-child {
          & > div {
            padding-right: 0;
          }
        }
      `}

      & > div {
        display: flex;
        height: 100%;
        padding: 0 15px;
        justify-content: center;
      }

      &:not(.slick-current) {
        opacity: 1;
      }
    }
  }

  // For chaging dots style
  .slick-prev:before,
  .slick-next:before {
    content: "" !important;
  }

  .slick-dots {
    font-size: 0;
    bottom: 0px;
    transform: translateY(100%);

    li {
      margin: 0 7.5px;

      &.slick-active button {
        background: ${({ theme }) => theme.sectionTheme?.text || defaultSectionTheme.text };
      }

      @media (hover: hover) {
        &:hover button {
          background: ${({ theme }) => theme.sectionTheme?.text || defaultSectionTheme.text };
        }
      }
    }

    li button {
      background: transparent;
      border: 1px solid ${({ theme }) => theme.sectionTheme?.text || defaultSectionTheme.text};
      width: 13px;
      height: 13px;
      border-radius: 50%;
      transition: .4s;
      cursor: pointer;

      &:before {
        display: none;
      }
    }
  }

  ${(props) => props.hasInnerShadow && css`
    ${({ theme }) => theme.mediaBreakpointUp.md} {
      margin-top: -30px;
      margin-bottom: -40px;
    }
  `}

  ${(props => props.length <= 1 && css`
    & > div {
      margin: 0 auto;
    }
  `)}

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    overflow: hidden;
    padding-bottom: ${props => props.length >= MAX_SLIDES - 2  ? 15 : 0}px;

    & > .slick-slider {
      padding-bottom: ${props => props.length >= MAX_SLIDES - 2 ? 35 : 0}px;
    }
  }

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    padding-bottom: ${props => props.length >= MAX_SLIDES ? 100 : 0}px;

    & > .slick-slider {
      padding-bottom: ${props => props.length > 2 ? 30 : 0}px;
    }

    .slick-list {
      .slick-slide {
        & > div {
          padding: 0 ${props => props.length >= DESIGN_MAX_SLIDES ? 15 : 34}px;
        }
      }
    }
  }

  ${({ theme }) => theme.mediaBreakpointUp.xl} {
    & > .slick-slider {
      padding-bottom: 0px;
    }
  }
`
